/**
 * @file PageHeader 页头
 * @description 标题 + 可选面包屑 / 描述 / 右侧操作。
 *
 * @whenToUse 后台内容区顶部页眉。
 * @whenNotToUse 全局顶栏（用 Topbar）；卡片内标题（用 CardHeader）。
 */

import type { ReactNode } from 'react'
import { cn } from '@/lib/cn.ts'
import { Breadcrumb, type BreadcrumbItem } from '@/components/ui/breadcrumb.tsx'

export type PageHeaderProps = {
  title: ReactNode
  description?: ReactNode
  breadcrumb?: BreadcrumbItem[]
  /** 右侧操作区 */
  extra?: ReactNode
  className?: string
}

export function PageHeader({
  title,
  description,
  breadcrumb,
  extra,
  className,
}: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {breadcrumb && breadcrumb.length > 0 ? (
        <Breadcrumb items={breadcrumb} />
      ) : null}
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0 space-y-0.5">
          <h1 className="text-sm font-medium tracking-tight text-foreground">
            {title}
          </h1>
          {description ? (
            <p className="text-xs text-muted">{description}</p>
          ) : null}
        </div>
        {extra ? (
          <div className="flex flex-wrap items-center gap-2">{extra}</div>
        ) : null}
      </div>
    </div>
  )
}
